var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_817)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 4C19.5229 4 24.0001 8.47715 24.0001 14V4H34.0001C39.5229 4 44.0001 8.47715 44.0001 14C44.0001 19.5228 39.5229 24 34.0001 24C39.5229 24 44.0001 28.4772 44.0001 34C44.0001 36.7423 42.8962 39.2268 41.1086 41.0334L41.0712 41.0711L41.038 41.1041C39.231 42.8943 36.7447 44 34.0001 44C31.2742 44 28.803 42.9093 26.9991 41.1405C26.9757 41.1175 26.9523 41.0943 26.929 41.0711C26.9071 41.0492 26.8853 41.0272 26.8636 41.0051C25.0925 39.2009 24.0001 36.728 24.0001 34C24.0001 39.5228 19.5229 44 14.0001 44C8.47721 44 4.00006 39.5228 4.00006 34V24H14.0001C8.47721 24 4.00006 19.5228 4.00006 14C4.00006 8.47715 8.47721 4 14.0001 4ZM22.0001 14C22.0001 18.4183 18.4184 22 14.0001 22V6C18.4184 6 22.0001 9.58172 22.0001 14ZM42.0001 34C42.0001 29.5817 38.4184 26 34.0001 26C29.5818 26 26.0001 29.5817 26.0001 34H42.0001ZM6.00006 26V34C6.00006 38.4183 9.58178 42 14.0001 42C18.4184 42 22.0001 38.4183 22.0001 34V26H6.00006ZM26.0001 22V6H34.0001C38.4184 6 42.0001 9.58172 42.0001 14C42.0001 18.4183 38.4184 22 34.0001 22H26.0001Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4.00006 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.a7c9ca975c0bf28ef5fd4a6d739cca13.svg";
export { ForwardRef as ReactComponent };